module.exports = "pegasus/assets/background-patterns/space.png";